// 语言选择器国旗 —— 14 面手绘简化 SVG，内联进 bundle。
//
// 为什么不用 Unicode regional indicator emoji（🇩🇪）：
//   Windows 系统字体不含国旗字形，regional indicator 对会退化成两个字母方块
//   （"D E"），macOS / iOS / Android 才正常渲染。访客侧一半以上是 Windows，
//   不能赌。
// 为什么不用 flag-icons 之类的图标库：它们带全世界 250+ 面旗，我们只要 14 面。
// 为什么不用外部图片：多一次 HTTP 请求 + CDN 依赖 + 宿主页 CSP（img-src）风险。
//
// 画法约定：
//   - 统一 viewBox "0 0 24 16"（3:2），几何为主，去掉细节徽章（巴西飘带文字、
//     印度法轮辐条、韩国卦象细节等一律简化），目标是 21×14 px 下可辨认。
//   - 每面只存「内部图形」，不存 <svg> 外壳；外壳与那层极淡描边由 renderFlag()
//     统一补，避免 14 份重复。
//   - 不使用 <defs> / clipPath / mask —— 同一个 shadow root 里 14 个内联 SVG
//     的 id 会互相撞车。圆角靠外层 span 的 border-radius + overflow:hidden。

export const FLAG_SHAPES = {
    // 美国：13 横条 + 左上蓝色矩形；星阵用 round dash 的三条虚线近似（比 15 个
    // <circle> 省 4 倍字节，20px 下视觉等价）
    en: '<rect width="24" height="16" fill="#fff"/>'
        + '<path d="M0 .6h24M0 3.1h24M0 5.5h24M0 8h24M0 10.5h24M0 12.9h24M0 15.4h24" stroke="#B22234" stroke-width="1.23"/>'
        + '<rect width="9.6" height="8.6" fill="#3C3B6E"/>'
        + '<path d="M1.4 2.2h6.8M1.4 4.3h6.8M1.4 6.4h6.8" stroke="#fff" stroke-width=".62" stroke-linecap="round" stroke-dasharray=".05 1.7"/>',

    // 西班牙：红-黄-红，黄条占一半高
    es: '<rect width="24" height="16" fill="#AA151B"/><rect y="4" width="24" height="8" fill="#F1BF00"/>',

    // 巴西（pt 指向 pt-BR，与落地站 og:locale 一致）：绿底 + 黄菱 + 蓝圆，去掉飘带
    pt: '<rect width="24" height="16" fill="#009B3A"/>'
        + '<path d="M12 2.3 21.3 8 12 13.7 2.7 8Z" fill="#FEDF00"/>'
        + '<circle cx="12" cy="8" r="3.1" fill="#002776"/>'
        + '<path d="M9.2 6.8c1.9-.7 4.1-.4 5.7.7" fill="none" stroke="#fff" stroke-width=".8"/>',

    // 法国：蓝-白-红竖三分
    fr: '<rect width="24" height="16" fill="#fff"/><rect width="8" height="16" fill="#0055A4"/><rect x="16" width="8" height="16" fill="#EF4135"/>',

    // 德国：黑-红-金横三分
    de: '<rect width="24" height="16" fill="#000"/><rect y="5.33" width="24" height="5.34" fill="#DD0000"/><rect y="10.67" width="24" height="5.33" fill="#FFCE00"/>',

    // 意大利：绿-白-红竖三分
    it: '<rect width="24" height="16" fill="#fff"/><rect width="8" height="16" fill="#009246"/><rect x="16" width="8" height="16" fill="#CE2B37"/>',

    // 俄罗斯：白-蓝-红横三分
    ru: '<rect width="24" height="16" fill="#fff"/><rect y="5.33" width="24" height="5.34" fill="#0039A6"/><rect y="10.67" width="24" height="5.33" fill="#D52B1E"/>',

    // 土耳其：红底 + 白月牙（大白圆挖一个偏移红圆）+ 白星
    tr: '<rect width="24" height="16" fill="#E30A17"/>'
        + '<circle cx="9.6" cy="8" r="3.5" fill="#fff"/>'
        + '<circle cx="11" cy="8" r="2.8" fill="#E30A17"/>'
        + '<polygon points="14.9,6.4 15.26,7.51 16.42,7.51 15.48,8.19 15.84,9.29 14.9,8.61 13.96,9.29 14.32,8.19 13.38,7.51 14.54,7.51" fill="#fff"/>',

    // 中国：红底 + 一大星（五角）+ 四小星（20px 下五角与圆点视觉等价，用圆点省字节）
    zh: '<rect width="24" height="16" fill="#DE2910"/>'
        + '<polygon points="5.5,2.6 6.08,4.4 7.97,4.4 6.44,5.51 7.03,7.3 5.5,6.19 3.97,7.3 4.56,5.51 3.03,4.4 4.92,4.4" fill="#FFDE00"/>'
        + '<g fill="#FFDE00"><circle cx="9.6" cy="2.6" r=".62"/><circle cx="11.2" cy="4.3" r=".62"/><circle cx="11.2" cy="6.6" r=".62"/><circle cx="9.6" cy="8.3" r=".62"/></g>',

    // 日本：白底红圆（白色系国旗——外层那层淡描边就是为它加的）
    ja: '<rect width="24" height="16" fill="#fff"/><circle cx="12" cy="8" r="4.8" fill="#BC002D"/>',

    // 韩国：白底 + 太极圆 + 四角卦（每角简化为三条细线）
    ko: '<rect width="24" height="16" fill="#fff"/>'
        + '<circle cx="12" cy="8" r="4" fill="#CD2E3A"/>'
        + '<path d="M12 4a2 2 0 0 1 0 4 2 2 0 0 0 0 4 4 4 0 0 1 0-8z" fill="#0047A0"/>'
        + '<g stroke="#111" stroke-width=".55">'
        + '<path d="M2.83 4.75 4.95 2.63M3.54 5.46 5.66 3.34M4.25 6.17 6.37 4.05"/>'
        + '<path d="M21.17 4.75 19.05 2.63M20.46 5.46 18.34 3.34M19.75 6.17 17.63 4.05"/>'
        + '<path d="M2.83 11.25 4.95 13.37M3.54 10.54 5.66 12.66M4.25 9.83 6.37 11.95"/>'
        + '<path d="M21.17 11.25 19.05 13.37M20.46 10.54 18.34 12.66M19.75 9.83 17.63 11.95"/>'
        + '</g>',

    // 泰国：红-白-蓝-白-红五横条（蓝条占 1/3）
    th: '<rect width="24" height="16" fill="#A51931"/><rect y="2.67" width="24" height="10.66" fill="#F4F5F8"/><rect y="5.33" width="24" height="5.34" fill="#2D2A4A"/>',

    // 印度尼西亚：红上白下
    id: '<rect width="24" height="16" fill="#fff"/><rect width="24" height="8" fill="#CE1126"/>',

    // 印度：橙-白-绿 + 蓝色法轮（简化为一个蓝圈 + 圆心）
    hi: '<rect width="24" height="16" fill="#fff"/>'
        + '<rect width="24" height="5.33" fill="#FF9933"/>'
        + '<rect y="10.67" width="24" height="5.33" fill="#138808"/>'
        + '<circle cx="12" cy="8" r="1.9" fill="none" stroke="#000080" stroke-width=".75"/>'
        + '<circle cx="12" cy="8" r=".5" fill="#000080"/>',
};

// 极淡描边：白色系国旗（日本 / 印尼 / 印度）在白色弹层底上要有边界
const FLAG_RING = '<rect width="24" height="16" fill="none" stroke="rgba(0,0,0,.16)" stroke-width="1.6"/>';

// 返回可直接喂给 dangerouslySetInnerHTML 的完整 <svg> 内部标记（含描边）。
// 内容全是本文件里的常量，没有任何外部输入拼接。
export function flagInnerHtml(code) {
    const shape = FLAG_SHAPES[code];
    if (!shape) return null;
    return shape + FLAG_RING;
}

export const FLAG_VIEWBOX = '0 0 24 16';
